export const SET_ERRORS = 'SET_ERRORS'
export const SET_NOTIFICATION = 'SET_NOTIFICATION'
export const SET_MAIN_SIDEBAR_COLLAPSED_STATUS = 'SET_MAIN_SIDEBAR_COLLAPSED_STATUS'
export const SET_NIGHT_MODE = 'SET_NIGHT_MODE'
